// New Task — a task é issue do LINEAR, no time `bymav`, criada pelo MCP do
// LiteLLM (não há chave do Linear no app). O status vem de `linear.statuses()`,
// que é a mesma fonte das colunas do board, e o identificador da task é o do
// Linear (BYM-1583).
//
// Saiu tudo que era do GitHub e não existe no Linear: label `estado:*`,
// `papel:*`, anexo commitado no repo, workflow do Actions com `schedule:` e a
// aba "From template" (que era arquivo em .github/ISSUE_TEMPLATE virando
// sub-issue). Simular isso aqui seria inventar dado.

import { linear, SourceError, type LinearStatus } from "../api";
import { errorBox, esc, head, skeleton, toast } from "../ui";

const CSS = `
.task-form-card { width: 60%; min-width: 460px; }
`;
if (!document.getElementById("css-task-form")) {
  const st = document.createElement("style");
  st.id = "css-task-form";
  st.textContent = CSS;
  document.head.append(st);
}

/** A escala de prioridade do Linear: 0=None, 1=Urgent … 4=Low. É o que
 *  `save_issue` aceita em `priority` — número, não texto. */
const PRIORIDADES: Array<{ valor: number; nome: string }> = [
  { valor: 0, nome: "None" },
  { valor: 1, nome: "Urgent" },
  { valor: 2, nome: "High" },
  { valor: 3, nome: "Medium" },
  { valor: 4, nome: "Low" },
];

/** Rota #/tasks/new. */
export async function taskForm(el: HTMLElement): Promise<void> {
  const header = head({
    title: "New Task",
    actions: `<a class="btn" href="#/tasks">Cancel</a>
      <button class="btn btn-primary" id="task-create" type="submit" form="task-form">Create</button>`,
  });

  el.innerHTML = header + skeleton();

  let statuses: LinearStatus[];
  let projetos: Array<{ id: string; name: string }>;
  try {
    [statuses, projetos] = await Promise.all([linear.statuses(), linear.projects()]);
  } catch (e) {
    // Enquanto o `linear_oficial` não estiver autorizado no LiteLLM, é aqui que
    // a tela para: a mensagem é a da origem, e não há formulário fingindo que
    // dá para criar.
    const err = e as SourceError;
    el.innerHTML =
      header + errorBox(err.source ?? "Linear", err.message, err.next ?? "tente de novo");
    return;
  }

  el.innerHTML = header + `
    <div id="tf-erro"></div>
    <form class="card task-form-card" id="task-form">
      <div class="field">
        <label class="label" for="tf-title">Title</label>
        <input class="input" id="tf-title" name="title" autocomplete="off" required />
      </div>
      <div class="field">
        <label class="label" for="tf-description">Description</label>
        <textarea class="textarea" id="tf-description" name="description" rows="8"
          placeholder="Describe what the agent should do..."></textarea>
      </div>
      <div class="field">
        <label class="label" for="tf-state">Status</label>
        <select class="select" id="tf-state" name="state">
          ${statuses
            .map(
              (s) =>
                `<option value="${esc(s.name)}"${s.name === "Todo" ? " selected" : ""}>${esc(s.name)}</option>`,
            )
            .join("")}
        </select>
      </div>
      <div class="field">
        <label class="label" for="tf-project">Project (optional)</label>
        <select class="select" id="tf-project" name="project">
          <option value="">No project</option>
          ${projetos.map((p) => `<option value="${esc(p.id)}">${esc(p.name)}</option>`).join("")}
        </select>
      </div>
      <div class="field">
        <label class="label" for="tf-priority">Priority</label>
        <select class="select" id="tf-priority" name="priority">
          ${PRIORIDADES.map((p) => `<option value="${p.valor}">${p.nome}</option>`).join("")}
        </select>
      </div>
    </form>`;

  const form = el.querySelector<HTMLFormElement>("#task-form")!;
  const caixaErro = el.querySelector<HTMLElement>("#tf-erro")!;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const d = new FormData(form);
    const title = String(d.get("title") ?? "").trim();
    if (!title) return toast("Toda task precisa de título");

    const description = String(d.get("description") ?? "").trim();
    const project = String(d.get("project") ?? "");
    const priority = Number(d.get("priority") ?? 0);

    const botao = el.querySelector<HTMLButtonElement>("#task-create")!;
    botao.disabled = true;
    caixaErro.innerHTML = "";
    try {
      const issue = await linear.salvaIssue({
        title,
        team: "bymav",
        // `save_issue` chama o campo de `state` e recusa chave desconhecida; o
        // valor é o nome do status como o time o define.
        state: String(d.get("state") ?? "Todo"),
        ...(description ? { description } : {}),
        ...(project ? { project } : {}),
        ...(priority ? { priority } : {}),
      });
      toast(`Task aberta como ${issue.id}`);
      location.hash = "/tasks";
    } catch (err) {
      const erro = err as SourceError;
      caixaErro.innerHTML = errorBox(
        erro.source ?? "Linear",
        erro.message,
        erro.next ?? "tente de novo",
      );
      botao.disabled = false;
    }
  });
}
